export default __webpack_public_path__ + "4520188144a17fb24a6af28a70dae0ce.ttf";